export { };
import { CommonUtilty } from "../utilities";
import * as moment from 'moment';

Array.prototype.getUniqueElements = function (uniqueKeyName) {
    const r = [];
    const m = new Map();
    for (const item of this) {
        if (!m.has(item[uniqueKeyName])) {
            m.set(item[uniqueKeyName], true);
            r.push(item);
        }
    }
    return r
}

Object.defineProperty(Object, "deepCopiedValue", {
    get: function deepCopiedValue() {
        try {
            return JSON.parse(JSON.stringify(this));
        }
        catch{

        }

    }
});

Array.prototype.isArrayIterable = function () {
    if (this && Array.isArray(this) && this.length > 0)
        return true
    else
        return false
}

Array.prototype.sortObjectList = function (sortOrderKey, ascDesc?, isDate?) {
    if (sortOrderKey && this) {
        let ascDescInput = ascDesc || 'asc'
        if (isDate) {
            return sortDateObject(sortOrderKey, this, ascDescInput)
        }
        else {
            return sortObject(sortOrderKey, this, ascDescInput)
        }
    }
}

Array.prototype.removeItemFromListUnSorted = function (i, o) {
    let newList = this.filter(item => item[o] != i[o])
    return newList
}

Array.prototype.sortObjectList = function (key, sortAscDesc, isDate?) {
    let output = []
    if (this.isArrayIterable()) {
        if (isDate)
            output = this.sort(compareDateValues(key, sortAscDesc))
        else {
            output = this.sort(compareValues(key, sortAscDesc))
        }
        return output
    }
    else {
        return this
    }

}

Array.prototype.mergeOnTargetArray = function (targetArray: Array<any>, compareKey: Array<any>) {
    if (this.isArrayIterable() && targetArray.isArrayIterable()) {
        let merge = (a, b, p) => a.filter(aa => !b.find(bb => aa[p] === bb[p])).concat(b);
        let output = merge(targetArray, this, compareKey)

        return output
    }
    else
        return []
}

Window.prototype.generateGuid = function () {
    var guid = ''
    guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    return guid
}

Window.prototype.deepCopy = function (o) {
    try {
        return JSON.parse(JSON.stringify(o));
    }
    catch{
        return null
    }
}


function sortObject(k, o, orderby) {
    return o.sort(compareValues(k, orderby))
}

function sortDateObject(k, o, orderby) {
    return o.sort(compareDateValues(k, orderby))
}

function compareValues(key, order) {
    return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
        }

        const varA = (typeof a[key] === 'string') ?
            a[key].toUpperCase() : a[key];
        const varB = (typeof b[key] === 'string') ?
            b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }
        return (
            (order == 'desc') ? (comparison * -1) : comparison
        );
    };
}

function compareDateValues(key, order) {
    return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
        }
        const varA = moment((typeof a[key] === 'string') ?
            a[key].toUpperCase() : a[key], ['DD-MM-YYYY', 'x']);
        const varB = moment((typeof b[key] === 'string') ?
            b[key].toUpperCase() : b[key], ['DD-MM-YYYY', 'x']);

        let comparison = 0;

        if (varA.isAfter(varB)) {
            comparison = 1;
        } else if (varB.isAfter(varA)) {
            comparison = -1;
        }
        return (
            (order == 'desc') ? (comparison * -1) : comparison
        );
    };
}

